import {Branding} from "../../types/Branding";

export interface IconMapping {
    readonly lightIcon: string;
    readonly darkIcon: string;
    readonly color: string;
}

const IV: IconMapping = {
    lightIcon: "assets/whitelabel/IV/img/favicon.ico",
    darkIcon: "assets/whitelabel/IV/img/favicon.ico",
    color: "#11C00C"
};

const IINVEST: IconMapping = {
    lightIcon: "assets/whitelabel/IINVEST/img/favicon.ico",
    darkIcon: "assets/whitelabel/IINVEST/img/favicon.ico",
    color: "#11C00C"
};

const TC: IconMapping = {
    lightIcon: "assets/whitelabel/TC/img/favicon.ico",
    darkIcon: "assets/whitelabel/TC/img/favicon.ico",
    color: "#11C00C"
};

const OPEN_TRADER: IconMapping = {
    lightIcon: "assets/whitelabel/OPEN_TRADER/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/OPEN_TRADER/favicon/favicon.ico",
    color: "#11C00C"
};

const OPEN_MARKETS: IconMapping = {
    lightIcon: "assets/whitelabel/OPEN_MARKETS/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/OPEN_MARKETS/favicon/favicon.ico",
    color: "#11C00C"
};

const BELLMONT: IconMapping = {
    lightIcon: "assets/whitelabel/BELLMONT/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/BELLMONT/favicon/favicon.ico",
    color: "#11C00C"
};

const FUTURE_ASSIST: IconMapping = {
    lightIcon: "assets/whitelabel/FUTURE_ASSIST/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/FUTURE_ASSIST/favicon/favicon.ico",
    color: "#11C00C"
};

const ALLFIN: IconMapping = {
    lightIcon: "assets/whitelabel/ALLFIN/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/ALLFIN/favicon/favicon.ico",
    color: "#243134"
};

const WAIMAK: IconMapping = {
    lightIcon: "assets/whitelabel/WAIMAK/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/WAIMAK/favicon/favicon.ico",
    color: "#11C00C"
};

const SUUBEE: IconMapping = {
    lightIcon: "assets/whitelabel/SUUBEE/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/SUUBEE/favicon/favicon.ico",
    color: "#11C00C"
};

const LIQUIDITY: IconMapping = {
    lightIcon: "assets/whitelabel/LIQUIDITY/favicon/favicon.ico",
    darkIcon: "assets/whitelabel/LIQUIDITY/favicon/favicon.ico",
    color: "#F7F8F9"
};

const TF: IconMapping = {
    lightIcon: "favicon.png",
    darkIcon: "favicon.png",
    color: "#11C00C"
};

export function iconMapping(branding: Branding): IconMapping {
    switch (branding) {
        case Branding.IV:
            return IV;
        case Branding.IINVEST:
            return IINVEST;
        case Branding.TC:
            return TC;
        case Branding.OPEN_TRADER:
            return OPEN_TRADER;
        case Branding.OPEN_MARKETS:
            return OPEN_MARKETS;
        case Branding.BELLMONT:
            return BELLMONT;
        case Branding.FUTURE_ASSIST:
            return FUTURE_ASSIST;
        case Branding.ALLFIN:
            return ALLFIN;
        case Branding.WAIMAK:
            return WAIMAK;
        case Branding.SUUBEE:
            return SUUBEE;
        case Branding.LIQUIDITY:
            return LIQUIDITY;
        default:
            return TF;
    }
}
